import { Trash } from '~/components/icons';
import { useFormContext } from "react-hook-form";
import { WelcomeFormSchema } from '../../pages/welcome/schema';

const MedicationInput = () => {
  const {
    watch,
    setValue,
  } = useFormContext<WelcomeFormSchema>();

  // Initialize medications from form if it exists, otherwise use empty array
  const medications = watch("medications") || [''];

  const handleMedicationChange = (index: number, value: string) => {
    const updatedMedications = [...medications];
    updatedMedications[index] = value;
    setValue("medications", updatedMedications, { shouldValidate: true });
  };

  const handleDeleteMedication = (index: number) => {
    if (medications.length === 1) {
      setValue("medications", [''], { shouldValidate: true });
    } else {
      const updatedMedications = medications.filter((_, i) => i !== index);
      setValue("medications", updatedMedications, { shouldValidate: true });
    }
  };

  const handleAddMedication = () => {
    setValue("medications", [...medications, ''], { shouldValidate: true });
  };

  return (
    <div className="w-full mx-auto">
      <div className="space-y-2 mb-4">
        {medications.map((medication, index) => (
          <div key={index} className="flex items-center gap-2">
            <div className="relative flex-grow">
              <input
                type="text"
                className="w-full border bg-transparent border-gray-300 rounded-lg p-3"
                placeholder="Please enter medication"
                value={medication}
                onChange={(e) => handleMedicationChange(index, e.target.value)}
              />
            </div>
            <button
              type="button" // Add type="button" to prevent form submission
              onClick={() => handleDeleteMedication(index)}
              className="p-2 text-gray-500 rounded-md hover:text-red-500 border border-[#DCDCDE]"
              aria-label="Delete medication"
            >
              <Trash size={18} />
            </button>
          </div>
        ))}
      </div>

      <div className='flex items-end justify-end w-full'>
        <button
          type="button" // Add type="button" to prevent form submission
          onClick={handleAddMedication}
          className="text-black border border-[#DCDCDE] shadow-sm py-2 px-4 rounded-lg flex items-center"
        >
          <span className="mr-1">+</span> Add medication
        </button>
      </div>
    </div>
  );
};

export default MedicationInput;